import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PathsService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { FormsUtils } from '../../form-builder/index';

@Component({
    selector: 'da-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ForgotPasswordFormComponent implements OnInit {
    forgotPasswordForm: UntypedFormGroup;
    loading = false;
    submitted = false;
    message = false;
    showMessage = false;
    public hasFocus = false;
    public success = true;
    // convenience getter for easy access to form fields
    linkLoginForm: string;
    private _$loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private formBuilder: UntypedFormBuilder,
        private authenticationService: AuthenticationService,
        private _pathsService: PathsService
    ) {}

    public get loaded$(): Observable<{}> {
        return this._$loaded.asObservable();
    }

    get f() {
        return this.forgotPasswordForm.controls;
    }

    ngOnInit() {
        this.linkLoginForm = this._pathsService.getAccountLink();
        this.success = false;
        this.forgotPasswordForm = this.formBuilder.group({
            username: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]]
        });
    }

    public hasValue(fieldname) {
        const _input = fieldname;
        return _input.value ? FormsUtils.trim(_input.value.toString()) !== '' : false;
    }

    onSubmit() {
        this.submitted = true;

        if (this.forgotPasswordForm.invalid) {
            return;
        }

        this._$loaded.next(false);
        this.authenticationService
            .forgotPassword(this.f.username.value)
            .pipe(first())
            .subscribe(
                (data) => {
                    this.showMessage = false;
                    this.success = true;
                    this._$loaded.next(true);
                },
                (error) => {
                    this.showMessage = false;
                    this.success = true;
                    this._$loaded.next(true);
                }
            );
    }
}
